import { LuckyWheelConstraintType } from '@/schema'
import { z } from 'zod'
import { walletConditionSchema } from '@/common/components/WalletConditionSection'

const wheelSettingSchema = z
	.object({
		id: z.string(),
		title: z.string().min(1, 'กรุณากรอกชื่อ'),
		probability: z
			.number()
			.min(0, 'เปอร์เซ็นต์ต้องมากกว่าหรือเท่ากับ 0')
			.max(100, 'เปอร์เซ็นต์ต้องน้อยกว่าหรือเท่ากับ 100'),
		type: z.string().min(1, 'กรุณากรอกประเภท'),
		amount: z
			.number({
				invalid_type_error: 'กรุณากรอกจำนวน',
				required_error: 'กรุณากรอกจำนวน',
			})
			.min(1, 'กรุณากรอกจำนวน'),
		color: z.string().regex(/^#[0-9A-F]{6}$/i, 'กรุณาเลือกสี'),
		// FREE_SPIN specific fields
		presetId: z.string().optional(),
		gameId: z.string().optional(),
		betAmount: z.number().optional(),
	})
	.refine(
		(data) => {
			if (data.type === 'FREE_SPIN') {
				return !!data.gameId && !!data.betAmount
			}
			return true
		},
		{
			message: 'กรุณากรอกข้อมูลเกมและจำนวนเดิมพันสำหรับฟรีสปิน',
			path: ['gameId'],
		},
	)

const constraintSchema = z.object({
	constraintType: z.enum([
		LuckyWheelConstraintType.LOSS,
		LuckyWheelConstraintType.TURNOVER,
		LuckyWheelConstraintType.DEPOSIT_WITH_BONUS,
	]),
	amount: z.number().min(1, 'จำนวนต้องมากกว่าหรือเท่ากับ 1'),
})

export const UpdateLuckyWheelFormSchema = z.object({
	isActive: z.boolean(),
	requireConnectedLine: z.boolean(),
	expiredIn: z.date(),
	claimConstraint: z.array(constraintSchema).optional(),
	wheelSetting: z.array(wheelSettingSchema),
	wheelUrl: z.string().optional(),
	arrowWheelUrl: z.string().optional(),
	showImageOnWheel: z.boolean(),
	walletCondition: walletConditionSchema.optional(),
})

export type UpdateLuckyWheelFormValues = z.infer<
	typeof UpdateLuckyWheelFormSchema
>
